module.exports = __webpack_public_path__ + "media/images/phone-icon-df7ddc3e02a886ed3e0323d9e987c2e8.png";